module.exports = {
  gallery: ["GALLERY"],
  institution: ["INSTITUTION", "INSTITUTIONAL_SELLER"],
}
